import './References.css';
import { useEffect } from 'react';

const recommendations = [
  {
    text: "The Lumo Quartet reflects in an extraordinary sensitive and clever mode Sibelius’ poetic transcription of the Finnish drama, still going on. They play with a remarkable clarity of soul. No hesitation to deal with the unknown and with an opaqueness without which music becomes boringly flat.",
    author: "Bo Ekman, Founder and Chairman Emeritus, Tällberg Foundation"
  },
  {
    text: "Teidän musiikki teki päivästämme juhlan isolla J:llä ja vieraamme ovat puhuneet teistä taukoamatta. Kiitos!! - - Olette todella rautaisia ammattilaisia!",
    author: "T & D"
  },
  {
    text: "Thank you thank you thank you! From the bottom of our hearts! We are still deeply touched by our wedding day, and all the music that you played. - - We have - and absolutely will warmly recommend you to anyone! You playing, was the icing on the cake for us!",
    author: "A & R"
  },
  {
    text: "Kaikki tapahtui alusta alkaen sujuvasti, missään vaiheessa ei tarvinnut stressata asioiden onnistumisesta! Meillä oli toiveena tiettyjä musiikkikappaleita, jotka Lumo Ensemble sovitti ja toteutti kauniisti. Lisäksi heillä oli tarjota kappaleita valittavaksi hääjuhlaamme. Luotettava ja kauniisti soittava kvartetti.",
    author: "Salla & Markus"
  },
  {
    text: "Lumo Ensemble oli soittamassa häissämme kesällä 2015 ja heidän soittonsa sekä monipuolinen ohjelmistonsa sai vuolaasti kehuja myös kaikilta häävierailtamme. Lumo Ensemble soitti ammattitaitoisesti sekä vihkimisen musiikit, että viihdemusiikin ruokailun ja kahvin aikana. Lisäksi he soittivat bändin mukana häätanssissamme. Yhteistyö heidän kanssaan sujui saumattomasti ja he toteuttivat hienosti kaikki toiveemme. Lumo Ensemble teki soitollaan päivästämme ikimuistoisen ja voimme lämpimästi suositella heitä tilaisuuksiin, joissa tarvitaan taidokkaasti soitettua jousimusiikkia.",
    author: "Juha & Lotta Mäkinen"
  },
  {
    text: "Kiitos vielä upeasta konsertista. Harmaa marraskuinen päivä muuttui ansiostanne aurinkoiseksi",
    author: "Pertti ja Hellevi"
  },
  {
    text: "Kiitos tuhannesti upeasta esityksestä. Pystyimme kumpikin jotenkin pitämään itsemme koossa, kunnes aloitte soittaa ja sitten loppuseremonia olikin yhtä kyynelten kuivaamista. Kiitos, kun loitte tunnelman ikimuistoiseen vihkitilaisuuteemme!",
    author: "Maria ja Mikko"
  },
  {
    text: "Soittonne loi sellaisen turvallisen kuplan, kuin kehdon, jossa sai olla tuuditettavana. Että on saanut syntyä tänne kokemaan tämä kiehtova maailma, on ihme. Musiikki on ihme.",
    author: "A. H."
  },
  {
    text: "You made a most remarkable contribution to the Svalbard conversations. Your music came to frame our meanderings of feelings, emotions and thoughts, starting with Beethoven’s monumental and ground breaking The Great Fuge. You gave it stature, strength and sensitivity. Further, it became congenial to end the event with Sibelius’ tender Dance with Death. You played it as exquisitely. When words fail to communicate, music picks up.​",
    author: "Bo Ekman, Co-Founder & Co-Chair Aurora Borealis Foundation"
  }
];


export default function References() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main id="top" className="references-page" >
  <h2>Referenssit</h2>
  <div className="references-list">
    {recommendations.map((ref, i) => (
      <div key={i} className="reference-card">
        <p className="quote">"{ref.text}"</p>
        <p className="author">– {ref.author}</p>
      </div>
    ))}
  </div>
</main>
  );
}


